export default __webpack_public_path__ + "static/media/slider01.5cfaff38.jpg";